import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'

// Registrar componentes
ChartJS.register(ArcElement, Tooltip, Legend)

const GraficoMovimentacao = ({ indicador }) => {
  // Dados fake
  const data = {
    labels: ['Entradas', 'Saídas'],
    datasets: [
      {
        data: [indicador.totalEntradas, indicador.totalSaidas], // valores
        backgroundColor: ['#59A68D', '#224650'],
        borderWidth: 1,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value) => value, // mostra o número
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px', textAlign: 'center' }}>
      <Doughnut data={data} options={options} />
    </div>
  )
}

export default GraficoMovimentacao
